import { message } from 'antd'
import { GroupsApi } from '../../../../api/Groups'
import RolesList from '../../../../components/Main/Group/Roles/RolesList'
import useFetchObject from '../../../../elements/Hooks/useFetchObject'
import useModalData from '../../../../elements/Hooks/useModalData'
import { isEmpty, omit, pick } from 'lodash'
import React, { useEffect, useState } from 'react'


function RolesListCont(props) {
  const groupID = props.group._key

  const [list, setList] = useState([])
  const { fetch, fetching, object: group } = useFetchObject(
    () => GroupsApi.read(groupID),
    false,
    [props.group._rev],
    isEmpty(groupID),
  )

  useEffect(() => {
    if (!isEmpty(group)) {
      setList(group.role)
    }
  }, [list, fetching])

  console.log({ list, group })
  const {
    visible,
    modalType,
    object: line,
    submitting,
    removing,
    setSubmitting,
    setRemoving,
    formRef,
    onShow,
    onCancel,
    checkForm,
  } = useModalData(undefined, undefined, undefined, fetch)

  async function submit() {
    const newObject = await checkForm()
    const Max = list ? Math.max(...list.map(o => o.id), 0) + 1 : 1
    const newItem = { id: `${Max}`, ...newObject }

    const newRole = list ? [...list] : []
    newRole.push(newItem)

    const newGroup = { ...group }
    newGroup.role = newRole
    console.log({ group, newGroup })

    setSubmitting(true)
    try {
      await GroupsApi.update({
        ...newGroup,
        ...pick(group, ['_id', '_key', '_rev']),
      })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  async function remove() {
    const newRole = list.filter(l => l.id !== line.id)

    const newGroup = { ...group }
    newGroup.role = newRole
    console.log({ group, newGroup })

    setRemoving(true)
    try {
      await GroupsApi.update({
        ...newGroup,
        ...pick(group, ['_id', '_key', '_rev']),
      })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setRemoving(false)
  }

  async function update() {
    const newObject = await checkForm()

    const newItem = { id: `${line.id}`, ...newObject }
    let newRoles = [...list]
    newRoles[newRoles.findIndex(l => l.id === line.id)] = newItem

    // const newRole = list.filter(l => l.id !== line.id)
    // newRole.push(newItem)
    //
    const newGroup = { ...group }
    newGroup.role = newRoles

    console.log({ group, newGroup })
    setSubmitting(true)
    try {
      await GroupsApi.update(
        omit(
          {
            ...newGroup,
            ...pick(group, ['_id', '_key']),
          },
          ['_rev'],
        ),
      )
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <RolesList
      {...{
        list,
        fetching,
        fetch,
        visible,
        submitting,
        group,
        line,
        onShow,
        onCancel,
        submit,
        removing,
        remove,
        update,
        modalType,
        formRef,
      }}
    />
  )
}

export default (RolesListCont)
